import React from 'react'

const Manual_descargar_respuestas_encuestas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Cómo Descargar las respuestas de las Encuestas
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a descargar las respuestas de tus encuestas para analizarlas y aprovechar mejor los datos de tus clientes.
        </p>
        <iframe
          src="https://scribehow.com/embed/Como_Descargar_las_respuestas_de_las_Encuestas__-g0ET6_rQc2qdWCFkezMUQ?as=scrollable"
          className="scribe-iframe-general-123"
          width="100%"
          height="3400"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_descargar_respuestas_encuestas
